var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSkipBack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9554 2.0658C13.1864 2.17682 13.3333 2.4104 13.3333 2.66667V13.3333C13.3333 13.5896 13.1864 13.8232 12.9554 13.9342C12.7244 14.0452 12.4503 14.014 12.2502 13.8539L5.5835 8.52059C5.42535 8.39407 5.33329 8.20253 5.33329 8.00001C5.33329 7.79748 5.42535 7.60594 5.5835 7.47943L12.2502 2.14609C12.4503 1.986 12.7244 1.95479 12.9554 2.0658ZM7.06715 8.00001L12 11.9463V4.05376L7.06715 8.00001ZM3.33329 2.66667C3.70148 2.66667 3.99996 2.96515 3.99996 3.33334V12.6667C3.99996 13.0349 3.70148 13.3333 3.33329 13.3333C2.9651 13.3333 2.66663 13.0349 2.66663 12.6667V3.33334C2.66663 2.96515 2.9651 2.66667 3.33329 2.66667Z",
    fill: "#02BF8E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkipBack);
export default __webpack_public_path__ + "static/media/skip-back.47928e84.svg";
export { ForwardRef as ReactComponent };